import request from '@/utils/request.js';

// 消息通知 接口api
export function CreateNoticeInfo(data) {
    // 创建消息通知[内部]
    return request({
        apiType: 'java',
        url: '/NoticeInfo/CreateNoticeInfo',
        method: 'post',
        data
    });
}

export function GetNoticeList(data) {
    // 消息通知汇总查询
    return request({
        apiType: 'java',
        url: '/NoticeInfo/GetNoticeList',
        method: 'post',
        data
    });
}

export function GetNoticePageList(data) {
    // 获取消息通知分页列表
    return request({
        apiType: 'java',
        url: '/NoticeInfo/GetNoticePageList',
        method: 'post',
        data
    });
}

export function UpdateNoticeRead(data) {
    // 更新消息已读
    return request({
        apiType: 'java',
        url: '/NoticeInfo/UpdateNoticeRead?' + `Id=${data.Id}`,
        method: 'post'
    });
}
